/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/

export interface BarcodeFormat {
  id: number;
  name: string;
  type: BarcodeTypeEnum;
  format: string;
  organizationId: number | null;
  organizationName: string | null;
}

export interface UpsertBarcodeFormatRequest {
  id: number | null;
  name: string | null;
  barcodeType: number | null;
  format: string | null;
  organizationId: number | null;
}

export enum BarcodeTypeEnum {
  Medication = 0,
  Patient = 1,
  SampleBag = 2,
  ExitSafeDevice = 3,
  TransportBag = 4,
  FurtherReviewBag = 5,
}
